import Head from "next/head";
import NavBar from "@/components/templates/NavBar";
import Slider from "@/components/templates/Slider";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import Footer from "@/components/templates/Footer";
import Newsletter from "@/components/templates/Newsletter";
import Booking from "@/components/templates/Booking";
import FaqsSection from "@/components/templates/faqs/FaqsSection";
export default function Page(props) {
  const { noIndex } = props;
  const { t } = useTranslation("common", "faqs", "routes");
  const faqsData = t("faqs:faqsData", {returnObjects:true})
  
  return (
    <>
      <Head>
        <title>{faqsData?.meta?.title}</title>
        <meta name="og:title" content={faqsData?.meta?.title} />
        <meta name="description" content={faqsData?.meta?.description} />
        <meta name="og:description" content={faqsData?.meta?.description} />
        <meta name="keywords" content={faqsData?.meta?.keywords} />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        {noIndex && <meta name="robots" content="noindex" />}
        <link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href={t('common:canonical_pages.faqs')} />
      </Head>
      <main>
        <NavBar />
        <Booking />
        <Slider sliders={faqsData?.sliders} />
        <FaqsSection data={faqsData?.faqs} title={faqsData?.title} text={faqsData?.text}/>
        <Newsletter />
        <Footer />
      </main>
    </>
  );
}

export async function getServerSideProps({ locale }) {
  const noIndex = process.env.ENV_NO_INDEX || false;
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common", "faqs", "routes"])),
      noIndex,
    },
  };
}
